import React from "react";
import * as Icons from "lucide-react";

export default function IconBox({ name = "Sparkles", className = "" }) {
  // Map a few aliases
  const map = { Tower: "TowerControl" };
  const real = map[name] || name;
  const Cmp = Icons[real] || Icons.Sparkles;
  return (
    <div className={`w-11 h-11 rounded-lg bg-[#f1f5f9] grid place-items-center text-navy ${className}`}>
      <Cmp className="w-5 h-5" />
    </div>
  );
}
